// extracted by mini-css-extract-plugin
export default {"input":"styles_input__wDJNI","container":"styles_container__xVcn5"};